<template>
	<div class="app-main">
		<el-row type="flex" class="app-main-header" align="middle">
			<el-col :span="10">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">审核详情</span>
				</div>
			</el-col>
			<el-col :span="14" class="app-main-header-btns">
				<el-button size="small" type="primary" v-show="(checkRole('cgy_role') || checkRole('pw') || checkRole('leader')  )&& xjOrder && xjOrder.orderState==4 && xjOrder.createUser != userInfo.id && xjOrder.auditStatus == 1" @click="openAuditOrder">审批 </el-button>
				<el-button size="small" type="primary" @click="$router.back(-1)">返回 </el-button>
			</el-col>
		</el-row>
		<div class="order-info-main">
			<el-card :class="['info-wrap',auditFlag?'has-audit-list':'']">
					<el-row class="mg-b5" v-if="xjOrder">
						<el-form :label-position="'top'" :model="'top'">
							<el-col :span="12">
								<el-form-item label="询价单标题">
									<div class="item-info">{{xjOrder.title}}</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="询价单号">
									<div class="item-info">{{xjOrder.xjOrder}}</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="询价方式">
									<div class="item-info">{{xjText}}</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="采购组织">
									<div class="item-info">{{xjOrder.buyerUnitName}}</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="本轮报价截止时间">
									<div class="item-info">{{xjOrder.bjJzTime}}</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="货币种类">
									<div class="item-info">{{currencyInfo.obj[xjOrder.currency]}}</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="是否含税">
									<div class="item-info">{{xjOrder.isConcatTax}}</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="采购员">
									<div class="item-info">{{xjOrder.userName}}</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="采购部门">
									<div class="item-info">{{xjOrder.cgbm}}</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="轮次">
									<div class="item-info">{{xjOrder.rounds}}</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="发布日期">
									<div class="item-info">{{xjOrder.fbTime}}</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="备注">
									<div class="item-info">{{xjOrder.remark}}</div>
								</el-form-item>
							</el-col>
						</el-form>
					</el-row>
				<!-- </div> -->
			</el-card>
			<div class="audit-wrap" v-if="auditFlag">
				<el-card class="box-card" style="min-height:calc(100vh - 115px);position: relative;">
					<div style="padding-bottom: 20px;display: flex;align-items: center;">
						<el-divider direction="vertical"></el-divider>
						<span>审核记录</span>
					</div>
					<div class="audit-list-box">
						<div class="audit-item" v-for="(item,index) in auditList" :key="index">
							<div class="bar">
								<div class="name-box">
									<p class="name">{{item.userName}}</p>
									<p class="time">{{item.createTime}}</p>
								</div>

								<el-tag type="success" v-if="item.auditStatus == 3">通过</el-tag>
								<el-tag type="danger" v-if="item.auditStatus == 2">驳回</el-tag>
								<!-- <el-tag type="info" v-if="item.operDesc != '通过' &&  item.operDesc != '驳回'">{{item.operDesc}}</el-tag> -->
							</div>
							<div class="bh-reson" v-if="item.auditRemark">{{item.auditRemark}}</div>
						</div>
					</div>
				</el-card>
			</div>
		</div>
		<AuditTender ref="AuditTenderRef" @callback="AuditTenderRefCallback" />
	</div>
</template>

<script>
 	// orderState 1:待询价,2:询价中,3:已结束询价待审批,4:询价审批中,5:定标审批被驳回,6:定标审批通过,7:已发布中标通知,
 	// gysOrderState // 1:待参与,2:已放弃,3:报价中,4:报价已提交,5:已中标,6:未中标
	import { exportInquiryDetail,finishOrderXj,auditOrder ,getOrderAuditListByOrderId,zhongbiaoOrderNotice} from '@/api/srm/inquiryDetail.js'
	import { inquiryById } from '@/api/srm/inquiry.js'
	import { joinInquiry,giveUpInquiry } from '@/api/srm/inquiryUser.js'
	import OrderHeader from '../../../components/OrderHeader'
	import { xjtypes } from'../../../utils/dict'
	import AuditTender from '../inquiryDetail/AuditTender'
	export default {
		name: "auditInfo",
		components:{
			OrderHeader,
			AuditTender
		},
		data() {
			return {
				xjtypes,
				auditFlag:false,
				activeName:'first',
				hId:this.$route.query.hId,
				show: this.$route.query.show,
				timer: null,
				loadingInstance: undefined,
				xjOrder: null,
				quertInfo: {
					page: 1, //当前页码
					limit: 2000, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: '',
						hId: this.$route.query.hId,
					}
				},
				auditList:[],	//	审核记录
			};
		},
		computed:{
			PAGESIZE:function(){
				return this.$store.getters['app/sizeInfo'];
			},
			userInfo:function(){
				return this.$store.getters['user/user'];
			},
			currencyInfo:function(){
				return this.$store.getters['app/currencyInfo'];
			},
			xjText:function(){
				let str = '';
				if(this.xjOrder && this.xjOrder.xjFs){
					this.xjtypes.forEach((item)=>{
						if(item.code == this.xjOrder.xjFs){
							str = item.name;
						}
					});
				}
				return str;
			}
		},
		created() {
			this.getInquiryById();
			console.log(this.$route)
		},
		mounted() {
		},
		methods: {
			getInquiryById() {
				let _this = this;
				inquiryById({
					id: _this.$route.query.hId
				}).then(response => {
					if (response.data.code === 0) {
						_this.xjOrder = response.data.data;
						console.log(_this.xjOrder)
							_this.getAuditLog();
					}
				});
			},
			openAuditOrder(){
				let _this = this;
				this.$refs.AuditTenderRef.auditOpen({id:_this.xjOrder.id})
			},
			AuditTenderRefCallback(obj){
				if(obj.type == 'updateInfo'){
					this.getInquiryById()
				}
			},
			// 获取审批日志
			getAuditLog(){
				let _this = this;
				getOrderAuditListByOrderId({orderId:_this.xjOrder.id}).then(({data:res})=>{
					console.log(res);
					_this.auditList = res.data||[];
					if(_this.auditList.length >0 && (_this.checkRole('cgy_role') || _this.checkRole('pw') || _this.checkRole('leader'))){
						_this.auditFlag = true;
						// _this.getAuditLog();
					}
				})
			},
		},
		watch:{
		}
	};
</script>
<style scoped="scoped" lang="scss">
	.order-info-main{
		width: 100%;
		display: flex;
		::v-deep .el-form-item__label{
			color: #999;
		}
		.item-info{
			width: calc(100% - 40px);
			height: 30px;
			line-height: 30px;
			border-bottom: 1px solid #e8e8e8;
			color: #333;
		}
		.info-wrap{
			width: calc(100% - 40px);
			padding: 0 20px;
			&.has-audit-list{
				width: calc(100% - 350px);
			}
		}
		.audit-wrap{
			width: 300px;
			// height: calc(100vh - 80px);
			/* background: #fff; */
			margin-left: 10px;
			margin-top: 0px;
			.audit-list-box{
                width: 100%;
				height: calc(100vh - 120px);
				overflow-y: auto;
                .audit-item{
                    margin-bottom: 30px;
					/* background: #eee; */
					border-bottom: 1px solid #e8e8e8;
                    .bar{
                        display: flex;
                        height: 40px;
                        justify-content: space-between;
						.name-box{
							.name{
								font-size: 14px;
								font-weight: 700;
								color: #333;
								line-height: 20px;
							}
							.time{
								font-size: 12px;
								color: #999;
								line-height: 20px;
							}
						}
                    }
                    .bh-reson{
                        width: calc(100% - 20px);
                        background: #eee;
                        text-align: justify;
                        padding: 10px;
                        margin: 10px 0;
						border-radius: 5px;
						font-size: 12px;
                    }
                }
            }
		}
	}
</style>
